import { generateApiClient } from '@guiker/rest-client'

import { AdminApi } from '../api-definition'
import { config } from '../config'

export const AdminApiClient = generateApiClient(config.apiName, AdminApi.routes)
